import { render, staticRenderFns } from "./Metrics.vue?vue&type=template&id=21c31368&"
import script from "./Metrics.vue?vue&type=script&lang=js&"
export * from "./Metrics.vue?vue&type=script&lang=js&"
import style0 from "./Metrics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports